import { Component, OnInit } from "@angular/core";
import { GlobalSandbox } from "../../shared/sandbox/providers/global.sandbox";
import { ConfigurationSandbox } from "../../shared/sandbox/providers/configuration.sandbox";
import { USECASE } from "../../shared/model/usecase.model";
@Component({
  selector: "id3-use-case-menu",
  templateUrl: "./use-case-menu.component.html",
  styleUrls: ["./use-case-menu.component.css"],
  providers: [GlobalSandbox, ConfigurationSandbox],
})
export class UseCaseMenuComponent implements OnInit {
  constructor(
    public globalSandbox: GlobalSandbox,
    public configurationSandbox: ConfigurationSandbox
  ) {
    // this.configurationSandbox.startState();
    this.configurationSandbox.setDefaultContent();
  }

  ngOnInit(): void {
    this.configurationSandbox.startState();
  }

  onGenericTouch() {
    this.globalSandbox.setBarcodeType("BioSeal");
    this.globalSandbox.setUseCase(USECASE.GENERIC);
    this.globalSandbox.increment();
  }

  onVaccintionTouch() {
    this.globalSandbox.setBarcodeType("DataMatrix");
    this.globalSandbox.setUseCase(USECASE.VACCINATION);
    this.configurationSandbox.setContentType(true);
    this.globalSandbox.increment();
  }

  onCovidTestTouch() {
    this.globalSandbox.setBarcodeType("DataMatrix");
    this.globalSandbox.setUseCase(USECASE.COVID_TEST);
    this.configurationSandbox.setContentType(true);
    this.globalSandbox.increment();
  }

  onAccreditationTouch() {
    this.globalSandbox.setBarcodeType("BioSeal");
    this.globalSandbox.setUseCase(USECASE.ACCREDITATION);
    this.configurationSandbox.setContentType(true);
    this.configurationSandbox.setBioSealFormat('BigSquare');
    this.globalSandbox.increment();
  }
}
